import {HostInfo} from './host';
import {CertificateInfo, EquipmentInfo, PledgeInfo, StuffInfo} from "../../interface/model/visitorExtends";
export interface VisitorExtendsInfo {
    seq:number,
    service:boolean,
    privacy:boolean,
    education?:boolean,
    stuffInfos?:Array<StuffInfo>,
    equipmentInfos?:Array<EquipmentInfo>,
    certificateInfos?:Array<CertificateInfo>,
    pledgeInfos?:Array<PledgeInfo>
}
export const constructVisitorExtendsInfo:VisitorExtendsInfo = {
    seq:null,
    service:true,
    privacy:true,
    education:false,
    stuffInfos:[],
    equipmentInfos:[],
    certificateInfos:[],
    pledgeInfos:[]
}
export interface VisitorInfo {
    seq:number,
    name:string,
    birthDay:string,
    phone:string,
    company:string,
    car:string,
    carFlag:string,
    card?:string,
    vipFlag?:string,
    checkIn?:string,
    checkOut?:string,
    visitorStatus?:string,
    standardFlag?:boolean,
    visitorExtendsInfo?: VisitorExtendsInfo,
    visitorTermsInfos?:Array<any>,
    visitorEquipmentInfo?:object,
    visitorCertificateInfo?:CertificateInfo,
    visitorEducationInfos?:Array<any>,
    visitorStuffInfos?:Array<any>,
    /*visitorSurveyInfos?:Array<any>,*/
    visitorApplicationInfo?:VisitorApplicationInfo
}

export interface VisitorApplicationInfo {
    seq:number,
    hostInfo:HostInfo,
    startDate:string,
    startTime:number,
    endDate:string,
    endTime:number,
    visitLocation:string,
    longTermFlag:boolean,
    certificateFlag:boolean,
    visitPurpose:string,
    visitPurposeDetail:string
}

export const constructVisitorInfo: VisitorInfo = {
    seq:null,
    name:'',
    birthDay:'',
    phone:'',
    company:'',
    carFlag:'false',
    car:'',
    vipFlag:'false',
    visitorExtendsInfo:constructVisitorExtendsInfo,
    visitorApplicationInfo:null,
}

export const constructVisitorApplicationInfo:VisitorApplicationInfo = {
    seq:null,
    hostInfo:null,
    startDate:'',
    startTime:0,
    endDate:'',
    endTime:0,
    visitLocation:'',
    longTermFlag:false,
    certificateFlag:true,
    visitPurpose:'',
    visitPurposeDetail:''
}